var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 177.356,
    viewBox: "0 0 1920 177.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wave",
    d: "M1920,301.66l-64-17.7c-64-17.7-192-53.111-320-82.654-128-29.1-256-53.443-384-35.407-128,17.372-256,77.122-384,94.493-128,18.036-256-6.307-384,0-128,5.864-256,41.272-320,58.975l-64,17.7H1920Z",
    transform: "translate(0 -159.712)",
    fill: "#e8eded"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.088bf0ca812c9f8cd6d75927191164ca.svg";
export { ForwardRef as ReactComponent };